import React, { useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'

import { getTheme } from '../../theme/theme'

import PageMetaContext from '../../context/page-meta-context';

import SectionContainer from '../section-container'
import SectionHeader from '../section-header'

import { PointList, Point, PointIconContainer, PointIcon, PointLabel } from './points.styles'


const Points = ({label,heading,items,overlap,color,overlapSmall,count}) => {
	const meta = useContext(PageMetaContext);
	return (
		<ThemeProvider theme={(theme) => ({...theme,...getTheme(color)})}>
			<SectionContainer overlap={overlap} overlapSmall={overlapSmall}>
				{heading && <SectionHeader label={label} heading={heading} />}
				<PointList>
					{items.map((item,index) => 
						<Point key={index}>
							{item.icon && <PointIconContainer><PointIcon src={item.icon.url} /></PointIconContainer>}
							<PointLabel>{item.label}</PointLabel>
						</Point>
					)}
				</PointList>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default Points;